import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import auth from '../store/auth';
import store from '../store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
    meta: {
      title: 'E-cademy Music - About',
    },
  },
  {
    path: '/change-log',
    name: 'Change Log',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/ChangeLog.vue'),
    meta: {
      title: 'E-cademy Music - Change Log',
    },
  },
  {
    path: '/contacts',
    name: 'Contacts',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Contacts.vue'),
    meta: {
      title: 'E-cademy Music - Contacts',
    },
  },
  {
    path: '/signin',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),
    meta: {
      title: 'E-cademy Music - Login',
    },
  },
  {
    path: '/teachers',
    name: 'Teachers',
    component: () => import(/* webpackChunkName: "teachers" */ '../views/Teachers.vue'),
    meta: {
      title: 'E-cademy Music - Teachers',
    },
  },
  {
    path: '/teachers/carousel',
    name: 'Teachers Grid',
    component: () => import(/* webpackChunkName: "teachers" */ '../components/teachers/TeacherListCarousel.vue'),
    meta: {
      title: 'E-cademy Music - Teachers',
    },
  },
  {
    path: '/registration',
    name: 'Registration',
    component: () => import(/* webpackChunkName: "register" */ '../views/Registration.vue'),
    meta: {
      title: 'E-cademy Music - Register',
    },
  },
  {
    path: '/student-dashboard',
    component: () => import('../views/StudentDashboard.vue'),
    meta: {
      requiresAuth: true,
      title: 'Student Dashboard',
    },
    children: [
      {
        path: '/',
        component: () => import('@/components/students/StudentProfile.vue'),
        meta: {
          requiresAuth: true,
          title: 'Student Dashboard',
        },
        children: [
          {
            path: '/',
            name: 'student-timeline',
            component: () => import('@/components/students/StudentTimeline.vue'),
            meta: {
              requiresAuth: true,
              title: 'Your Dashboard',
            },
          },
          {
            path: 'messages',
            component: () => import('@/components/Messages.vue'),
            meta: {
              requiresAuth: true,
              title: 'Your Messages',
            },
          },
          {
            path: 'notifications',
            component: () => import('@/components/Notifications.vue'),
            meta: {
              requiresAuth: true,
              title: 'Your Notifications',
            },
          },
          {
            path: 'calendar',
            component: () => import('@/components/students/StudentCalendar.vue'),
            meta: {
              requiresAuth: true,
              title: 'Your Calendar',
            },
          },
          {
            path: 'payment-methods',
            component: () => import('@/components/students/StudentPaymentMethods.vue'),
            meta: {
              requiresAuth: true,
              title: 'Your Payment Methods',
            },
          },
          {
            path: 'profile',
            component: () => import('@/components/students/Profile.vue'),
            meta: {
              requiresAuth: true,
              title: 'Your Timezones',
            },
          },
        ],
      },
      {
        path: 'classrooms',
        component: () => import('@/components/students/StudentClassrooms.vue'),
        meta: {
          requiresAuth: true,
          title: 'Your Classrooms',
        },
      },
      {
        path: 'masterclasses',
        component: () => import('@/components/students/StudentMasterclasses.vue'),
        meta: {
          requiresAuth: true,
          title: 'Your Masterclasses',
        },
      },
      {
        path: 'teachers',
        component: () => import('@/components/TeachersOfStudent.vue'),
        meta: {
          requiresAuth: true,
          title: 'Your Teachers',
        },
      },
      {
        path: 'skills',
        component: () => import('@/components/students/SkillForm.vue'),
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    path: '/teacher-dashboard',
    component: () => import('../views/TeacherDashboard.vue'),
    meta: {
      requiresAuth: true,
      title: 'Your Dashboard',
    },
    children: [
      {
        path: '/',
        component: () => import('@/components/teachers/TeacherProfile.vue'),
        meta: {
          requiresAuth: true,
          title: 'Your Dashboard',
        },
        children: [
          {
            path: '/',
            name: 'teacher-timeline',
            component: () => import('@/components/teachers/TeacherTimeline.vue'),
            meta: {
              requiresAuth: true,
              title: 'Your Dashboard',
            },
          },
          {
            path: 'messages',
            component: () => import('@/components/Messages.vue'),
            meta: {
              requiresAuth: true,
              title: 'Your Messages',
            },
          },
          {
            path: 'notifications',
            component: () => import('@/components/Notifications.vue'),
            meta: {
              requiresAuth: true,
              title: 'Your Notifications',
            },
          },
          {
            path: 'calendar',
            component: () => import('@/components/teachers/TeacherCalendarManaged.vue'),
            name: 'teacher calendar',
            meta: {
              requiresAuth: true,
              title: 'Your Calendar',
            },
          },
          {
            path: 'reviews',
            component: () => import('@/components/teachers/TeacherReviews.vue'),
            meta: {
              requiresAuth: true,
              title: 'Your Reviews',
            },
          },
          {
            path: 'profile',
            component: () => import('@/components/teachers/Profile.vue'),
            meta: {
              requiresAuth: true,
              title: 'Your Timezones',
            },
          },
          {
            path: 'skills',
            component: () => import('@/components/teachers/SkillForm.vue'),
            meta: { requiresAuth: true },
          },
          {
            path: 'settings',
            component: () => import('@/components/teachers/TeacherClassSettings.vue'),
            meta: { requiresAuth: true },
          },
        ],
      },
      {
        path: 'classrooms',
        component: () => import('@/components/teachers/TeacherClassrooms.vue'),
        meta: {
          requiresAuth: true,
          title: 'Your Classrooms',
        },
      },
      {
        path: 'masterclasses',
        component: () => import('@/components/teachers/TeacherMasterclasses.vue'),
        meta: {
          requiresAuth: true,
          title: 'Your Masterclasses',
        },
      },
      {
        path: 'masterclasses/:id',
        component: () => import('@/components/masterclasses/Masterclass.vue'),
        meta: {
          requiresAuth: true,
          title: 'Your Masterclass',
        },
      },
      {
        path: 'students',
        component: () => import('@/components/StudentsOfTeacher.vue'),
        meta: {
          requiresAuth: true,
          title: 'Your Students',
        },
      },
      {
        path: 'payments',
        component: () => import('@/components/teachers/TeacherPayments.vue'),
        meta: {
          requiresAuth: true,
          title: 'Received Payments',
        },
      },
    ],
  },
  {
    path: '/teacher-dashboard/tiers',
    component: () => import('@/views/TeacherTiers.vue'),
    meta: {
      requiresAuth: true,
      title: 'Your Tiers',
    },
  },
  {
    path: '/teacher-dashboard/templates',
    component: () => import('../views/TeacherTemplates.vue'),
    meta: {
      requiresAuth: true,
      title: 'Your Templates',
    },
  },
  {
    path: '/teacher-dashboard/templates/new',
    component: () => import('../views/NewTemplate.vue'),
    meta: {
      requiresAuth: true,
      title: 'Create New Template',
    },
  },
  {
    path: '/teacher-dashboard/templates/:id',
    component: () => import('../views/TeacherTemplate.vue'),
    meta: {
      requiresAuth: true,
      title: 'Your Templates',
    },
  },
  {
    path: '/teacher-dashboard/media',
    component: () => import('../views/TeacherMedia.vue'),
    meta: {
      requiresAuth: true,
      title: 'Your Media',
    },
  },
  {
    path: '/teacher-dashboard/classrooms/:slug',
    component: () => import('../views/TeacherClassroom.vue'),
    meta: {
      requiresAuth: true,
      title: 'Your Classroom',
    },
  },
  {
    path: '/student-dashboard/classrooms/:slug',
    component: () => import('../views/StudentClassroom.vue'),
    meta: {
      requiresAuth: true,
      title: 'Your Classroom',
    },
  },
  {
    path: '/admin-dashboard',
    component: () => import('../views/AdminDashboard.vue'),
    meta: {
      requiresAuth: true,
      title: 'Your Dashboard',
    },
  },
  {
    path: '/teachers/:slug',
    component: () => import('../views/Teacher.vue'),
    children: [
      {
        path: '/',
        name: 'teacher',
        component: () => import('@/components/teachers/TeacherInfo.vue'),
        meta: {
          title: 'E-cademy Music - Teacher',
        },
      },
      {
        path: 'calendar',
        component: () => import('@/components/teachers/TeacherCalendar.vue'),
        meta: {
          requiresAuth: true,
          title: 'E-cademy Music - Calendar',
        },
      },
      {
        path: 'lessons',
        component: () => import('@/components/teachers/Tiers.vue'),
        meta: {
          title: 'E-cademy Music - Lessons',
        },
      },
      {
        path: 'masterclasses',
        component: () => import('@/components/teachers/TeacherMasterclasses.vue'),
        meta: {
          title: 'E-cademy Music - Masterclasses',
        },
      },
      {
        path: 'reviews',
        component: () => import('@/components/teachers/TeacherOutsideReviews.vue'),
        meta: {
          title: 'E-cademy Music - Reviews',
        },
      },
      {
        path: 'statistics',
        component: () => import('@/components/teachers/TeacherStatistics.vue'),
        meta: {
          requiresAuth: true,
          title: 'E-cademy Music - Statistcs',
        },
      },
      {
        path: 'students',
        component: () => import('@/components/StudentsOfTeacher.vue'),
        meta: {
          requiresAuth: true,
          title: 'E-cademy Music',
        },
      },
    ],
  },
  {
    path: '/students/:slug',
    component: () => import('../views/Student.vue'),
    children: [
      {
        path: '/',
        name: 'student',
        component: () => import('@/components/students/StudentInfo.vue'),
        meta: {
          requiresAuth: true,
          title: 'Your Timezones',
        },
      },
      {
        path: 'statistics',
        component: () => import('@/components/students/StudentStatistics.vue'),
        meta: {
          requiresAuth: true,
          title: 'E-cademy Music - Statistics',
        },
      },
      {
        path: 'masterclasses',
        component: () => import('@/components/students/StudentMasterclasses.vue'),
        meta: {
          title: 'E-cademy Music - Masterclasses',
        },
      },
      {
        path: 'teachers',
        component: () => import('@/components/TeachersOfStudent.vue'),
        meta: {
          requiresAuth: true,
          title: 'E-cademy Music',
        },
      },
    ],
  },
  {
    path: '/lesson/goodbye',
    name: 'bye',
    component: () => import('../views/LessonLogout.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/payment',
    name: 'payment',
    component: () => import('../views/Payment.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/failed-payment',
    name: 'failed payment',
    component: () => import('../views/FailedPayment.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/failed-authorization',
    name: 'failed authorization',
    component: () => import('../views/FailedAuthorization.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/masterclasses',
    name: 'Masterclasses',
    component: () => import('../views/Masterclasses.vue'),
  },
  {
    path: '/masterclasses/:id',
    component: () => import('@/views/MasterclassDetails.vue'),
  },
  {
    path: '/lesson-review',
    component: () => import('@/views/StudentReview.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/verify-email',
    component: () => import('@/views/VerifyEmail.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash,
        offset: { y: 150 },
        behavior: 'smooth',
      };
    }
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    store.dispatch('auth/auth').then(() => {
      if (!store.getters['auth/authenticated']) {
        next({
          name: 'Login',
          query: { redirect: to.fullPath },
        });
      } else next();
    });
  }
  if (to.fullPath === '/signin') {
    if (auth.state.authenticated) {
      next('/');
    }
  }
  if (to.fullPath === '/registration') {
    if (auth.state.authenticated) {
      next('/');
    }
  }

  next();
});

const DEFAULT_TITLE = 'E-cademy Music';
router.afterEach((to) => {
  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  Vue.nextTick(() => {
    document.title = to.meta.title || DEFAULT_TITLE;
  });
});

export default router;
